import React from 'react';
import styles from './solution_item.module.css';

const SolutionItem = ({ solution }) => {
  const { icon, title, description } = solution;

  return (
    <div className={styles.item}>
      {solution && (
        <>
          <div className={styles.iconBox}>
            <img
              src={process.env.PUBLIC_URL + `/imgs/main/solution/${icon}`}
              alt={title}
            />
          </div>

          <div className={styles.textBox}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default SolutionItem;
